// extracted by mini-css-extract-plugin
export var donationForm = "Donations-module--donation-form--2xIV1";
export var donationText = "Donations-module--donation-text--32gYt";
export var donationLink = "Donations-module--donation-link--2lq35";